export const SET_TOKEN = '@token/SET_TOKEN';
export const CLEAR_TOKEN = '@token/CLEAR_TOKEN';
